import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Section from '../components/layout/Section'
import Reveal from '../components/layout/Reveal'
import Seo from '../components/seo/Seo'
import { useBreadcrumbs } from '../seo/useBreadcrumbs'
import { AREAS } from '../data/areas'

export default function AreasIndex() {
  const crumbs = useBreadcrumbs([{ label: 'Areas', path: '/areas' }])
  return (
    <div className="bg-neutral-charcoal">
      <Seo
        title="Delaware Beach Towns & Communities We Serve | Merritt & Shawn | Coastal Delaware Real Estate"
        description="Local guides to Lewes, Rehoboth Beach, Dewey Beach, Bethany Beach, Fenwick Island, and Milton — neighborhoods, lifestyle, and live listings in each Delaware beach town."
        path="/areas"
        jsonLd={[crumbs.jsonLd]}
      />
      <Section className="bg-neutral-charcoal pt-28 pb-16">
        {crumbs.node}
        <Reveal>
          <div className="mb-12">
            <p className="font-display text-[12px] uppercase tracking-[0.3em] font-medium text-white/70">
              Areas We Serve
              <span className="block w-6 h-[2px] bg-accent-gold mt-3" aria-hidden="true" />
            </p>
            <h1 className="mt-4 font-display uppercase text-white leading-none text-[clamp(36px,5.5vw,72px)]">
              <span className="font-thin">Delaware Beach </span>
              <span className="font-bold">Towns & Communities</span>
            </h1>
            <p className="mt-4 max-w-2xl text-lg text-white/70 font-light leading-[1.9]">
              Every town at the Delaware beaches has its own rhythm — the historic
              canal streets of Lewes, Rehoboth&apos;s boardwalk energy, the Quiet
              Resorts, and Milton&apos;s value just inland. These are our streets;
              let us walk you through them.
            </p>
          </div>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {AREAS.map((area) => (
            <Reveal key={area.slug}>
              <Link
                to={`/areas/${area.slug}`}
                className="group block border border-white/10 bg-white/5 overflow-hidden hover:border-accent-gold/50 transition-colors"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={area.heroImage}
                    alt={area.heroAlt}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h2 className="font-display text-xl font-bold text-white uppercase tracking-wide">
                    {area.name}
                  </h2>
                  <p className="mt-2 text-white/60 font-light leading-relaxed line-clamp-2">
                    {area.intro[0]}
                  </p>
                  <span className="mt-4 inline-flex items-center gap-2 font-display text-[12px] uppercase tracking-[0.2em] text-accent-gold">
                    {area.name} real estate guide
                    <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </Section>
    </div>
  )
}
